<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">Add RedChirp User</v-card-title>

    <v-card-text>

    <v-form v-model="is_valid">

        <m-contact-line 
            left_icon="mdi-account" 
            label="First Name" 
            v-model="first_name"
            no_right_column
        />

        <m-contact-line 
            label="Last Name" 
            v-model="last_name"
            no_right_column
        />

        <m-contact-line 
            left_icon="mdi-email" 
            label="Username (email address)" 
            v-model="username"
            email
            no_right_column
            v-on:input="checkUsername"
        />

        <p
            style="font-weight: bold; color: red"
        >
            {{username_used_in_other_orgs_pretty}}
        </p>

        <m-contact-line 
            left_icon="mdi-lock" 
            label="Current Password" 
            v-model="current_password"
            password
            no_right_column
            v-if="username_used_in_other_orgs_pretty != null && !$rc.$state.isAuthActorSystemAdmin()"
            hint="You must enter the current password because this user spans organizations"
        />

        <m-contact-line 
            left_icon="mdi-cellphone" 
            label="Personal Cell Phone Number (optional)" 
            v-model="personal_cell"
            phone_number
            no_right_column
        />

        <m-contact-line 
            left_icon="mdi-map-clock" 
            label="Timezone" 
            v-model="timezone"
            timezone
            no_right_column
        />

        <m-contact-line 
            left_icon="mdi-account-group" 
            label="Teams" 
            v-model="on_teams"
            :items="choice_teams"
            multiselect
            no_right_column
            v-if="!in_simple_mode"
        />

        <m-contact-line 
            left_icon="mdi-account-key-outline" 
            label="Account Type" 
            v-model="account_type"
            :items="choices_account_type"
            select
            no_right_column
        />

        <m-contact-line 
            label="Payment Permissions" 
            v-model="payment_permissions"
            :items="choices_payment_permissions"
            select
            no_right_column
            v-if="account_type != 'org-admin'"
        />

        <m-contact-line 
            label="Bulk Message Permissions" 
            v-model="bulk_message_permissions"
            :items="choices_bulk_message_permissions"
            select
            no_right_column
            v-if="account_type != 'org-admin'"
        />

        
        
        <v-row dense
            v-if="!in_simple_mode"
        >
            <v-col class="flex-grow-0 align-self-start" style="min-width: 40px">
                <v-icon >mdi-phone</v-icon>
            </v-col>

            <v-col>

                <v-radio-group 
                    v-model="team_member_phone_number" 
                    :mandatory="true"
                    style="margin-top: 0px; padding-top: 0px;"
                >
               
                    <v-radio
                        label="Register a new phone number"
                        value="new_number"
                    />
                    
                    <v-radio 
                        v-for="number in available_numbers"
                        :key="number"
                        :label="prettyPrint(number)" 
                        :value="number"
                    >
                    </v-radio>

                    <v-radio
                        label="Do not use an individual number"
                        value="no_number"
                    />
                </v-radio-group>
            </v-col>
        </v-row>

    </v-form>
    </v-card-text>

    <v-card-actions>
        
        <v-btn
            color="gray darken-1"
            text
            @click="in_simple_mode = false"
            v-if="in_simple_mode"
        >
            Show more settings
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
            :disabled="!is_valid || !requiredFieldsPresent()"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>

const E164 = require('@/js/E164.js');
const Validation = require('@/js/validate.js');
const { v4: uuidv4 } = require('uuid');
const _ = require('lodash');

export default {

    props: {
        simple_create_team_member_dialog: {
            type: Boolean,
            default: function() { return false; }
        },
    },

    data() {
        return {
            dialog: false,
            first_name: null,
            last_name: null,
            username: null,
            team_member_phone_number: 'new_number',
            available_numbers: [],
            is_valid: false,
            organization_id: null,
            personal_cell: null,
            timezone: null,
            teams: [],
            on_teams: [],
            username_used_in_other_orgs: [],
            current_password: null,
            in_simple_mode: false,

            account_type: 'ordinary-user',

            choices_account_type: [
                { 'text' : 'Organization Administrator', 'value' : 'org-admin' },
                { 'text' : 'Ordinary User', 'value' : 'ordinary-user' },
            ],

            payment_permissions: 'request-and-process',

            choices_payment_permissions: [
                { 'text' : 'Request and Process All Payments', 'value' : 'request-and-process' },
                { 'text' : 'Request and Process Your Own Payments', 'value' : 'request-and-self-process' },
                { 'text' : 'Request Only', 'value' : 'request-only' },
                { 'text' : 'No Access', 'value' : 'no-access' },
            ],

            bulk_message_permissions: 'send-bulk-messages',

            choices_bulk_message_permissions: [
                { 'text' : 'Prepare and Send Bulk Messages', 'value' : 'send-bulk-messages' },
                { 'text' : 'Prepare Bulk Messages', 'value' : 'prepare-bulk-messages' },
                { 'text' : 'No Access', 'value' : 'no-access' },
            ]
        }
    },

    methods: {
        showDialog(organization_id, organization_numbers, teams) 
        {
            this.in_simple_mode = this.simple_create_team_member_dialog;

            if ( teams == null ) 
                teams = [];

            this.teams = teams;

            this.dialog = true;
            this.username_used_in_other_orgs = [];

            this.organization_id = organization_id;
            this.first_name = null;
            this.last_name = null;
            this.username = null;
            this.team_member_phone_number = 'new_number';
            this.available_numbers = [];
            this.personal_cell = "";
            this.timezone = this.$rc.$state.profile.employee_account.time_zone;
            this.on_teams = [];
            this.current_password = null;
            
            for ( let i = 0; i < organization_numbers.length; i++ )
            {
                if ( organization_numbers[i].assignment != 'available' )
                    continue;

                this.available_numbers.push(organization_numbers[i].endpoint);
            }
        },
        
        onOk()
        {
           this.dialog = false;

            let new_employee_data = {
                'organization_id' : this.organization_id,
                'employee_id' : uuidv4(),
                'first_name' : this.first_name,
                'last_name' : this.last_name,
                'username' : this.username,
                'team_member_phone_number' : this.team_member_phone_number,
                'personal_cell' : this.personal_cell,
                'time_zone' : this.timezone,
                'teams' : this.on_teams,
                'account_type' : this.account_type,
                'payment_permissions' : this.payment_permissions,
                'bulk_message_permissions' : this.bulk_message_permissions,
                'current_password' : this.current_password,
            };

           this.$emit('ok', new_employee_data);
        },

        prettyPrint(number)
        {
            return E164.prettyPrintUsPhoneNumber(number);
        },

        requiredFieldsPresent() 
        {
            return Validation.notBlank(this.first_name) && Validation.notBlank(this.last_name) && Validation.notBlank(this.username) && Validation.isEmailAddress(this.username);
        },

        checkUsername: _.debounce(function(){
            this.doCheckUsername();
        }, 751),
        
        doCheckUsername()
        {
            
            this.$rc.rest(
                'LIST: /api/v1/list-orgs-with-username',
            
                {
                    'username': this.username,
                },
            
                (data) => {
                    this.username_used_in_other_orgs =  data.results;

                    if ( data.other_account != null )
                    {
                        let oa = data.other_account;
                        this.first_name = oa.comp_employee_first_name;
                        this.last_name = oa.comp_employee_last_name;

                        if ( oa.personal_devices.length > 0 )
                            this.personal_cell = this.$rc.pretty(oa.personal_devices[0].endpoint,'endpoint_no_parens');

                        this.time_zone = oa.time_zone;
                        this.account_type = oa.is_organization_admin ? 'org-admin' : 'ordinary-user';
                        this.payment_permissions = oa.payment_permissions;
                        this.bulk_message_permissions = oa.bulk_message_permissions;
                    }
                },
            
                () => {
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },
        
    },

    computed: {
        choice_teams() {
            let ret = [];

            for ( let i = 0; i < this.teams.length; i++ )
            {
                let item = this.teams[i];

                ret.push({
                    'text' : item.label,
                    'value' : item.employee_group_id
                });
            }

            return ret;
        },

        username_used_in_other_orgs_pretty()
        {
            if ( this.username_used_in_other_orgs.length == 0 ) 
                return null;

            return this.username + ' is also a user in '+this.$rc.pretty(this.username_used_in_other_orgs,'comma_and_list');
        },
    },

   
}
</script>

<style lang="scss" scoped>

</style>